import React from 'react'
import PropTypes from 'prop-types'
import { PersonalDetails } from 'LiveBoard/components/shared/SellerCard'
import { ContactDetails } from '../ContactDetails'
import CallToActionContainer from 'LiveBoard/containers/CallToActionContainer'
import { CTA_AREAS } from 'LiveBoard/components/shared/CallToAction/constants'
import { TAB_INDEXES } from 'shared/helpers/AccessibilityHelper'

const OpenedCard = (props) => {
  const {
    config, lead, themeColorHex, seller,
    onCtaOpen, onCtaClose, additionalDataStyle
  } = props

  return (
    <div className="card opened">
      <PersonalDetails seller={seller} />
      <div
        className="open-card-additional-data"
        style={additionalDataStyle}>
        <ContactDetails seller={seller} />
        { config.cta.show && (
          <CallToActionContainer
            config={{...config.cta}}
            themeColorHex={themeColorHex}
            area={CTA_AREAS.sellerCard}
            onOpen={onCtaOpen}
            onCancel={onCtaClose}
            onClose={onCtaClose}
            tabIndex={TAB_INDEXES.OpenedCard} />
          )
        }
      </div>
    </div>
  )
}

OpenedCard.propTypes = {
  config: PropTypes.object.isRequired,
  lead: PropTypes.object.isRequired,
  themeColorHex: PropTypes.string.isRequired,
  seller: PropTypes.object.isRequired,
  onCtaOpen: PropTypes.func
}

export default OpenedCard
